export const cssUtil = {
    parseInt: v => v ? parseInt(v, 10) : 0,
    parseDouble: v => v ? parseFloat(v) : 0,
    toStyleString(styleObj) {
        return Object.entries(styleObj)
            .map(([key, value]) => `${key}: ${value};`)
            .join(" ");
    },

    px(value) {
        if (value == null) return null;

        // numbers → add px
        if (typeof value === "number") {
            return `${value}px`;
        }

        if (typeof value === "string") {
            const v = value.trim();
            if (/^-?\d+(\.\d+)?(px|em|rem|%|vh|vw|vmin|vmax)$/.test(v)) {
                return v;
            }
            if (/^-?\d+(\.\d+)?$/.test(v)) {
                return `${v}px`;
            }

            return v;
        }

        return value;
    },

    getCssColor(color) {
        if (!color || color.type !== "solid") return null;

        const r = color.r ?? 0;
        const g = color.g ?? 0;
        const b = color.b ?? 0;
        const a = color.a ?? 1;

        return `rgba(${r}, ${g}, ${b}, ${a})`;
    },

    getCssGradient(gradient) {
        if (!gradient || gradient.type !== "gradient") return null;

        const degree = gradient.degree ?? 0;
        const colors = gradient.gradientColors ?? [];

        if (!colors.length) return null;

        const stops = colors
            .slice()
            .sort((a, b) => a.position - b.position)
            .map(c =>
                `rgba(${c.r}, ${c.g}, ${c.b}, ${c.a ?? 1}) ${c.position}%`
            )
            .join(", ");

        if (gradient.gradientType === "Linear") {
            return `linear-gradient(${degree}deg, ${stops})`;
        }

        if (gradient.gradientType === "Radial") {
            return `radial-gradient(${stops})`;
        }

        return null;
    },
    convertRgbaToRgb(input) {
        if (!input) return input;
    
        const rgbaPattern =
            /([a-zA-Z-]+):\s*rgba\s*\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([01](?:\.\d+)?)\s*\)\s*;?/g;
    
        return input
            .replace(rgbaPattern, (_, prop, r, g, b, a) => {
                const alpha = parseFloat(a);
                if (alpha === 0) {
                    return ""; 
                }
                return `${prop}: rgb(${r}, ${g}, ${b});`;
            })
            .replace(/\s*;\s*;/g, ";")
            .replace(/\s+/g, " ")
            .replace(/;\s+/g, "; ")
            .trim();
    },
    updateFontSize(content, newFontSize) {
        return content.replace(
          /font-size:\s*\d+(\.\d+)?px/gi,
          `font-size:${newFontSize}px`
        );
      }      
    
};
